<template>
    <div class="page">
        <navigation-bar Close :name="rewardPointInfo.name"/>
        <div class="tabs">
            <div @click="toSlide(0)" :class="{'active' : tabNum === 0}">
                說明
            </div>
            <div @click="toSlide(1)" :class="{'active ': tabNum === 1}">
                紀錄
            </div>
        </div>
        <div class="main pb-4">
            <!--APP用-有滑動效果-->
            <swiper ref="mySwiper" :options="swiperOptions" v-if="!isWeb">
                <swiper-slide>
                    <div class="swipe-content">
                        <div class="swipe-con">
                            <BonusPointsDetail :rewardPointInfo="rewardPointInfo" @triggerEvent="detailTriggerEvent" v-if="isSetUp"/>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="swipe-content">
                        <div class="swipe-con">
                            <BonusPointsRecord :rewardPointInfo="rewardPointInfo" :isReloadRecord="isReloadRecord" />
                        </div>
                    </div>
                </swiper-slide>
            </swiper>

            <!--網頁用-->
            <template v-else>
                <BonusPointsDetail :rewardPointInfo="rewardPointInfo" isWeb @triggerEvent="detailTriggerEvent" v-if="tabNum === 0 && isSetUp "/>
                <BonusPointsRecord :rewardPointInfo="rewardPointInfo" :isReloadRecord="isReloadRecord" v-if="tabNum === 1"/>
            </template>
        </div>
    </div>
</template>

<script>
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    let vm = null;

    import BonusPointsDetail from '../gift/components/BonusPointsDetail'
    import BonusPointsRecord from '../gift/components/BonusPointsRecord'
    import * as constDefine from "@/store/constDefine";
    export default {
        name: "BonusPointsPage",
        props: {
            isWeb: Boolean,
            dataTokenWeb: {default: ''},
        },
        components: {
            Swiper,
            SwiperSlide,
            BonusPointsDetail,
            BonusPointsRecord,
        },
        data() {
            return {
                //目前索引值(說明 紀錄)
                tabNum: 0,
                //swiper套件設定
                swiperOptions: {
                    on: {
                        slideChange(){
                            // 这里有坑，需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
                            const index = this.activeIndex
                            vm.tabNumber(index);
                        },
                    }
                },
                dataToken: this.isWeb? (this.dataTokenWeb.dataToken || "") : (this.$route.query.dataToken || ""),
                dataObject: {
                    "id": 0,
                },
                rewardPointInfo: {
                    "id": 0,
                    "name": "",
                    "content": "",
                    "imgUrl": "",
                    "contentPrecautions": [],
                    "useTypeList":  [],
                    "isAppUse": false,
                    "appUseType": 0,
                    "rewardPointUserId": 0,
                    "rewardPointUserPoint": 0,
                    "discount": 0,
                    "expiringPoint": 0,
                    "notActivePoint": 0,
                    "usedPoint": 0,
                    "invalidPoint": 0,
                    "giftLimitType": 0,
                    "isCanUseObject": false,
                    "useObjectName": '',
                    "scanParamData": {},
                },
                cameraResult: "",
                scanParamData: {},
                fromRoute: {},
                isReloadRecord: false,
                isSetUp: false,
            }
        },
        created() {
            vm = this;
            try {
                this.dataObject = this.$crypto.uriComponentToObject(this.dataToken);
                if(this.dataObject.usedType === this.$route.name || this.$route.name==='WebStoreRewardPoint' || this.$route.name==='WebStoreMember') {
                  let scanResult = sessionStorage.getItem('cameraResult');
                  if (scanResult !== null && scanResult !== '') {
                    //讀取完要清除，要再取得結果就要重新掃描
                    sessionStorage.setItem('cameraResult', '');

                    //讀取掃描結果
                    this.cameraResult = this.$store.state.scanResult;
                    this.$store.commit('clrScanResult');

                    let scanParamData = JSON.parse(this.cameraResult);

                    if(scanParamData.usedType === constDefine.QRCodeUsedType.GetInfo) {
                      this.scanParamData = scanParamData

                      let usePoint = sessionStorage.getItem('scanQRCodeUseRewardPointUsePoint') || 0;
                      this.scanParamData.usePoint = Number(usePoint)

                      sessionStorage.removeItem('scanQRCodeUseRewardPointUsePoint')
                    }
                  }

                  this.setupData();
                } else {

                    if(!this.isWeb){
                        this.$router.push({name:'Error'});
                    }else {
                        //單店網頁版用
                        this.$emit('close');
                    }

                    return false;
                }
            } catch (e) {
                if(!this.isWeb){
                    this.$router.push({name:'Error'});
                }else {
                    //單店網頁版用
                    this.$emit('close');
                }

                return false;
            }
        },
        beforeRouteEnter: function(to, from, next) {
          next(
              vm=>{
                vm.fromRoute = from;
              }
          );
        },
        methods: {
            toSlide(index) {
                if(!this.isWeb){
                    this.$refs.mySwiper.$swiper.slideTo(index)
                }else {
                    //單店網頁版用
                    this.tabNum = index
                }
            },
            tabNumber(index) {
                this.tabNum = index
            },
            setupData(){
              this.$http.fetchWithAuthEncrypt`GetMyselfRewardPointInfo${{
                "id": Number(this.dataObject.id),
                "checkType":   this.scanParamData.type || 0,
                "checkId":   this.scanParamData.id || 0,
              }}
              ${json => {
                if (json.status && json.data.id > 0) {
                    let data = json.data;
                    this.rewardPointInfo.id = data.id;
                    this.rewardPointInfo.name = data.name;
                    this.rewardPointInfo.content = data.content;
                    this.rewardPointInfo.imgUrl = data.imgUrl;
                    this.rewardPointInfo.contentPrecautions = data.contentPrecautions;
                    this.rewardPointInfo.useTypeList = data.useTypeList;
                    this.rewardPointInfo.isAppUse = data.isAppUse;
                    this.rewardPointInfo.appUseType = data.appUseType;
                    this.rewardPointInfo.rewardPointUserId = data.rewardPointUserId;
                    this.rewardPointInfo.rewardPointUserPoint = data.rewardPointUserPoint;
                    this.rewardPointInfo.discount = data.discount;
                    this.rewardPointInfo.expiringPoint = data.expiringPoint;
                    this.rewardPointInfo.notActivePoint = data.notActivePoint;
                    this.rewardPointInfo.usedPoint = data.usedPoint;
                    this.rewardPointInfo.invalidPoint = data.invalidPoint;
                    this.rewardPointInfo.giftLimitType = data.giftLimitType;
                    this.rewardPointInfo.isCanUseObject = data.isCanUseObject;
                    this.rewardPointInfo.useObjectName = data.useObjectName;
                    this.rewardPointInfo.scanParamData = JSON.parse(JSON.stringify(this.scanParamData));

                    if(this.scanParamData.usePoint > 0 || this.fromRoute.name === "TransferBonusPoints") {
                        this.toSlide(0)
                    }
                    //避免重新setupData時，因有殘留scanParamData導致誤判，所以清掉
                    this.scanParamData = {}
                } else {
                    this.$public.showNotify(json.message, false);
                }

                this.isSetUp = true;
              }}`;
            },
            detailTriggerEvent(obj) {
                if(obj.event === "setupData") {
                    this.setupData()
                    this.isReloadRecord = true;
                    setTimeout(() => {
                        this.isReloadRecord = false;
                    },500)
                }
            },
        }
    }
</script>
<style lang="less" scoped src="../../less/gift.less"/>
